/**
 * @generated SignedSource<<3a287f8603250d4bcfa340f08a133c0c>>
 * @relayHash 7fdc4a8b53b49ddfa954865ceb36f19e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 37d268d7e189244c2485e7f63d82c6610aa4201a00aec643ec30383b07b411b3

import type { ConcreteRequest, Mutation } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraMultiValueFieldOperations = "ADD" | "REMOVE" | "SET" | "%future added value";
export type JiraUpdateComponentsFieldInput = {
  id: string;
  operations: ReadonlyArray<JiraComponentFieldOperationInput>;
};
export type JiraComponentFieldOperationInput = {
  ids: ReadonlyArray<string>;
  operation: JiraMultiValueFieldOperations;
};
export type components_issueFieldComponents_ComponentsField_Mutation$variables = {
  input: JiraUpdateComponentsFieldInput;
};
export type components_issueFieldComponents_ComponentsField_Mutation$data = {
  readonly jira: {
    readonly updateComponentsField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly " $fragmentSpreads": FragmentRefs<"components_issueFieldComponentsInlineEditFull_ComponentsInlineEditViewWithIsEditable_fragmentRef">;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type components_issueFieldComponents_ComponentsField_Mutation$rawResponse = {
  readonly jira: {
    readonly updateComponentsField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly fieldId: string;
        readonly id: string;
        readonly name: string;
        readonly selectedComponentsConnection: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly label: string | null | undefined;
              readonly value: string;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly type: string;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type components_issueFieldComponents_ComponentsField_Mutation = {
  rawResponse: components_issueFieldComponents_ComponentsField_Mutation$rawResponse;
  response: components_issueFieldComponents_ComponentsField_Mutation$data;
  variables: components_issueFieldComponents_ComponentsField_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ]
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "components_issueFieldComponents_ComponentsField_Mutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraComponentsFieldPayload",
            "kind": "LinkedField",
            "name": "updateComponentsField",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraComponentsField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "components_issueFieldComponentsInlineEditFull_ComponentsInlineEditViewWithIsEditable_fragmentRef"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "components_issueFieldComponents_ComponentsField_Mutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraComponentsFieldPayload",
            "kind": "LinkedField",
            "name": "updateComponentsField",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraComponentsField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "name"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "fieldId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "type"
                  },
                  {
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1000
                      }
                    ],
                    "concreteType": "JiraComponentConnection",
                    "kind": "LinkedField",
                    "name": "selectedComponentsConnection",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraComponentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraComponent",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": "value",
                                "kind": "ScalarField",
                                "name": "id"
                              },
                              {
                                "alias": "label",
                                "kind": "ScalarField",
                                "name": "name"
                              },
                              (v4/*: any*/)
                            ]
                          }
                        ]
                      }
                    ],
                    "storageKey": "selectedComponentsConnection(first:1000)"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "37d268d7e189244c2485e7f63d82c6610aa4201a00aec643ec30383b07b411b3",
    "metadata": {},
    "name": "components_issueFieldComponents_ComponentsField_Mutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "55d6de75b11bbe1bea570947ba244198";

export default node;
